import { gql } from '@apollo/client/core';
import { containerBlockFragment } from '../fragments/container-block.fragment';

export const GET_CONTAINER_BLOCKS = gql`
  query getContainerBlocks($ids: [String!]!) {
    containerBlockCollection(where: { sys: { id_in: $ids } }, limit: 20) {
      items {
        ...ContainerBlockFields
        sys {
          id
        }
      }
    }
  }
  ${containerBlockFragment}
`;
